function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { Component } from "react";
import propTypes from "prop-types";
import cn from "classnames";
import { context, updateContextState, withContext } from "../wr-context";
import connectRequest from "../../utils/connect-request";
import { requests } from "../../modules/decision-tree";
import BuildQuote from "./build-quote";
import Card from "../card";
import { Grid } from "../grid";
import Progress from "../progress";
import Button from "../button";
import { MutedText, MediumText, EngravedText, CenteredText, PrimaryText } from "../text";
import { FaCheck } from "react-icons/fa";
import { MdReplay } from "react-icons/md";
import i18n, { getLocalizedProperty } from "../../utils/i18n";
import { tryCallRenderProp } from "../../utils/try-call";
import Link from "../link";
import { HeaderContainer, RenderHelpText, DecisionTreeContainer, DecisionTreeBody, DecisionTreeFooter, AnswerText, AnswersSummary, AnswerIcon, HelperText } from "./style";
import { generateTransaction } from "../../utils/transactions";
import mixpanel from "mixpanel-browser";
import { isAnalyticsEnabled } from "../../modules/analytics";
var _DecisionTree = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(_DecisionTree, Component);
    var _super = _createSuper(_DecisionTree);
    function _DecisionTree(props) {
        _classCallCheck(this, _DecisionTree);
        var _this;
        var ref;
        _this = _super.call(this, props);
        _this.currentQuestion = {};
        _this.currentAnswer = {};
        _this.currentQuestionNumber = 1;
        _this.resetDecisionTree = function() {
            _this.currentQuestion = {};
            _this.currentQuestionNumber = 1;
            _this.currentAnswer = {};
            _this.setState({
                currentQuestion: _this.props.startOverResetFlow ? context.state.flow.question : _this.props.flow,
                buildQuote: false,
                animateContent: true,
                autoMoved: false
            });
            context.actions.resetAnswers();
            if (_this.props.onReset) {
                _this.props.onReset();
            }
        };
        _this.answerSelected = function(answer, question) {
            var selectedAnswers = {};
            var decisionTreeAnswers = _this.props.decisionTreeAnswers;
            if (decisionTreeAnswers[_this.currentQuestionNumber] && decisionTreeAnswers[_this.currentQuestionNumber].id !== answer.id) {
                var newAnswers = {};
                Object.keys(decisionTreeAnswers).map(function(key) {
                    if (Number(key) < Number(_this.currentQuestionNumber)) {
                        newAnswers[key] = decisionTreeAnswers[key];
                    }
                });
                selectedAnswers = _objectSpreadProps(_objectSpread({}, newAnswers), _defineProperty({}, _this.currentQuestionNumber, _objectSpreadProps(_objectSpread({}, answer), {
                    question: question
                })));
            } else {
                selectedAnswers = _objectSpreadProps(_objectSpread({}, decisionTreeAnswers), _defineProperty({}, _this.currentQuestionNumber, _objectSpreadProps(_objectSpread({}, answer), {
                    question: question
                })));
            }
            context.actions.setAnswers(_objectSpread({}, selectedAnswers));
        };
        _this.setCurrentQuestion = function(currentQuestion) {
            _this.setState({
                currentQuestion: currentQuestion,
                animateContent: false
            }, function() {
                setTimeout(function() {
                    _this.setState({
                        animateContent: true
                    });
                }, 0);
            });
        };
        _this.nextQuestion = function(ev) {
            var ref, _props, ref1;
            var decisionTreeAnswers = _this.props.decisionTreeAnswers;
            var currentQuestion = _this.currentQuestion;
            _this.currentQuestionNumber += 1;
            if (_this.currentQuestion && !_this.currentQuestion.final && ((ref = _this.currentQuestion) === null || ref === void 0 ? void 0 : ref.id) === (_this.state.currentQuestion || _this.props.flow.question).id) {
                currentQuestion = decisionTreeAnswers[_this.currentQuestionNumber - 1].question;
            }
            var dTreeState = {
                selectedAnswers: decisionTreeAnswers,
                currentQuestion: _this.currentQuestion,
                currentQuestionNumber: _this.currentQuestionNumber,
                currentAnswer: _this.currentAnswer
            };
            if (currentQuestion.childType === "flow") {
                _this.props.getNextDecisionTreeFlowsFetch(_this.currentAnswer.childValue);
            }
            // Make sure this was called after a button click
            if (ev) {
                var flow = _this.props.flow;
                var q = _this.state.currentQuestion;
                generateTransaction({
                    action: "answered",
                    type: "question",
                    id: q.id,
                    hname: q.value,
                    processTransaction: function(t) {
                        var reqData = t.requestData;
                        reqData.answer = {
                            id: dTreeState.currentAnswer.id,
                            name: dTreeState.currentAnswer.value
                        };
                    }
                });
                isAnalyticsEnabled() && mixpanel.track(context.constants.analytics.decisionTreeAnswered, {
                    answer: dTreeState.currentAnswer.value,
                    question: q.value
                });
            }
            _this.setCurrentQuestion(currentQuestion);
            (ref1 = (_props = _this.props).onNextQuestion) === null || ref1 === void 0 ? void 0 : ref1.call(_props, currentQuestion, dTreeState);
        };
        _this.previousQuestion = function() {
            var _props = _this.props, decisionTreeAnswers = _props.decisionTreeAnswers, flow = _props.flow;
            var q1ForTransaction = _this.state.currentQuestion;
            _this.currentQuestionNumber -= 1;
            var currentQuestion = _this.currentQuestionNumber === 0 ? flow.question : decisionTreeAnswers[_this.currentQuestionNumber].question;
            _this.currentQuestion = currentQuestion;
            _this.setCurrentQuestion(currentQuestion);
            var q2ForTransaction = _this.currentQuestion;
            generateTransaction({
                action: "skipped back",
                type: "question",
                id: q1ForTransaction.id,
                hname: q1ForTransaction.value,
                processTransaction: function(t) {
                    var reqData = t.requestData;
                    reqData.prevQuestion = {
                        id: q2ForTransaction.id,
                        name: q2ForTransaction.value
                    };
                }
            });
            isAnalyticsEnabled() && mixpanel.track(context.constants.analytics.decisionTreeSkipBack, {
                currentQuestion: q1ForTransaction.value,
                previousQuestion: q2ForTransaction.value
            });
        };
        _this.handleBackToQuestions = function() {
            var restoreState = _this.props.restoreState;
            if (restoreState) {
                var p = Object.keys(restoreState).map(function(k) {
                    _this[k] = restoreState[k];
                    // Wait for all setStates to flush before calling previousQuestion
                    return new Promise(function(resolve) {
                        return _this.setState(_defineProperty({}, k, restoreState[k]), resolve);
                    });
                });
                Promise.all(p).then(function() {
                    return _this.previousQuestion();
                });
            } else {
                _this.previousQuestion();
            }
        };
        _this.buildQuote = function() {
            _this.setState({
                buildQuote: true
            });
        };
        _this.renderCard = function(param) {
            var Header = param.Header, Body = param.Body, Footer = param.Footer, question = param.question;
            var ref;
            var _state = _this.state, buildQuote = _state.buildQuote, animateContent = _state.animateContent;
            var _props = _this.props, submitProposal = _props.submitProposal, buildQuoteLabel = _props.buildQuoteLabel, _$RenderHelpText = _props.RenderHelpText, _hideHelpText = _props.hideHelpText, hideHelpText = _hideHelpText === void 0 ? false : _hideHelpText, _asDoc = _props.asDoc, asDoc = _asDoc === void 0 ? true : _asDoc, _asPdf = _props.asPdf, asPdf = _asPdf === void 0 ? true : _asPdf, _showVMSButton = _props.showVMSButton, showVMSButton = _showVMSButton === void 0 ? false : _showVMSButton, initialValues = _props.initialValues, valuesTypes = _props.valuesTypes, validationSchema = _props.validationSchema, noSummary = _props.noSummary, noBuildQuote = _props.noBuildQuote, renderFinalQuestionHelpText = _props.renderFinalQuestionHelpText, finalStepTitleHide = _props.finalStepTitleHide, emailSupportLabel = _props.emailSupportLabel, startOverBtnEachQuestion = _props.startOverBtnEachQuestion, decisionTreeAnswers = _props.decisionTreeAnswers;
            var questionValues = (ref = getLocalizedProperty(question, "value")) === null || ref === void 0 ? void 0 : ref.split("  ");
            var header = questionValues === null || questionValues === void 0 ? void 0 : questionValues[0];
            var ref1 = question !== null && question !== void 0 ? question : {}, _answers = ref1.answers, answers = _answers === void 0 ? [] : _answers;
            var displaySelectedIcon = context.theme.components.decisionTree.displaySelectedIcon;
            var values = questionValues === null || questionValues === void 0 ? void 0 : questionValues.slice(1).filter(function(v) {
                if (v && !v.includes("[object Object]")) {
                    return v;
                }
            });
            if (_this.props.customFinalProductsView && question.final && question.type === "products" && question.products && question.products.length) {
                return _this.props.customFinalProductsView(question, decisionTreeAnswers);
            }
            return /*#__PURE__*/ React.createElement(DecisionTreeContainer, null, question.final && finalStepTitleHide ? /*#__PURE__*/ React.createElement("br", null) : /*#__PURE__*/ React.createElement(Header, {
                className: "decision-tree-header"
            }, /*#__PURE__*/ React.createElement(HeaderContainer, null, buildQuote ? i18n("decisionTree.quoteBuilder.buildQuoteHeader") : header, _this.props.showQuestionHelper && /*#__PURE__*/ React.createElement(HelperText, {
                style: {
                    fontSize: "14px"
                }
            }, question.help))), buildQuote && /*#__PURE__*/ React.createElement(BuildQuote, {
                Body: Body,
                Footer: Footer,
                asDoc: asDoc,
                asPdf: asPdf,
                showVMSButton: showVMSButton,
                submitProposal: submitProposal,
                initialValues: initialValues,
                valuesTypes: valuesTypes,
                validationSchema: validationSchema,
                animateContent: animateContent,
                DecisionTreeBody: DecisionTreeBody,
                DecisionTreeFooter: DecisionTreeFooter,
                resetDecisionTree: _this.resetDecisionTree,
                question: question,
                className: "build-quote"
            }), !buildQuote && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Body, {
                verticalScroll: true
            }, /*#__PURE__*/ React.createElement(DecisionTreeBody, {
                className: animateContent ? "toggleAnimation" : ""
            }, renderFinalQuestionHelpText && question.final && tryCallRenderProp(renderFinalQuestionHelpText, {
                props: {
                    answer: question.answer
                },
                shouldDefaultRender: function() {
                    return false;
                }
            }), (values === null || values === void 0 ? void 0 : values.length) > 0 && /*#__PURE__*/ React.createElement("div", {
                className: cn("question", {
                    "question-final": question.final,
                    "no-quote": question.noQuote
                })
            }, values.map(function(value, index) {
                var isEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value.trim());
                return /*#__PURE__*/ React.createElement("p", {
                    key: index
                }, isEmail ? /*#__PURE__*/ React.createElement("a", {
                    href: "mailto:".concat(value)
                }, emailSupportLabel || value) : value);
            })), question.final && question.type === "products" && question.products && question.products.length && question.products.map(function(v) {
                return /*#__PURE__*/ React.createElement("p", {
                    key: v.id
                }, /*#__PURE__*/ React.createElement(Link, {
                    to: context.getRoutePath("productDetail", {
                        productId: v.id
                    })
                }, v.name));
            }), question.final && _this.props.sowBuilderSummaryText && /*#__PURE__*/ React.createElement(PrimaryText, null, /*#__PURE__*/ React.createElement(MediumText, {
                className: "question-summary"
            }, _this.props.sowBuilderSummaryText)), !noSummary && question.final && !question.noQuote && Object.keys(decisionTreeAnswers).map(function(key) {
                var ref;
                /*#__PURE__*/ return React.createElement(AnswersSummary, {
                    key: decisionTreeAnswers[key].id
                }, /*#__PURE__*/ React.createElement("p", {
                    className: "question-summary"
                }, (ref = decisionTreeAnswers[key].question) === null || ref === void 0 ? void 0 : ref.split("  ").join(" ")), /*#__PURE__*/ React.createElement("p", {
                    className: "answer-summary"
                }, getLocalizedProperty(decisionTreeAnswers[key], "value")));
            }), !question.final && /*#__PURE__*/ React.createElement(React.Fragment, null, answers.length > 0 && answers.map(function(answer, i) {
                var selectedAnswer = (decisionTreeAnswers[_this.currentQuestionNumber] || {}).id === answer.id;
                if (selectedAnswer) {
                    var ref;
                    var noQuote = answer.help && answer.help.toLowerCase() === "noquote";
                    var isProduct = answer.childType === "product";
                    var isFlow = answer.childType === "flow";
                    var isProductMessage = "Final Step  ".concat(answer.help || "");
                    var finalStepValue = "Final Step  ".concat(answer.childValue);
                    var finalQuestion = {
                        value: isProduct ? isProductMessage : !noQuote ? finalStepValue : "".concat(answer.childValue),
                        productId: isProduct ? answer.childValue : "",
                        type: answer.childType,
                        childValue: answer.childValue,
                        products: answer.products,
                        bundles: answer.bundles,
                        final: true,
                        noQuote: noQuote,
                        answer: answer
                    };
                    _this.currentQuestion = isFlow ? question.answers.find(function(ans) {
                        return ans.id === answer.id;
                    }) : ((ref = question.answers.find(function(ans) {
                        return ans.id === answer.id;
                    })) === null || ref === void 0 ? void 0 : ref.question) || _objectSpread({}, finalQuestion);
                    _this.currentAnswer = question.answers.find(function(ans) {
                        return ans.id === answer.id;
                    }) || {};
                }
                return /*#__PURE__*/ React.createElement(Button, {
                    key: answer.id,
                    "data-testid": "d3-answer-".concat(i),
                    className: cn("answer-button", {
                        selected: selectedAnswer
                    }),
                    onClick: function() {
                        _this.answerSelected(answer, question);
                    }
                }, /*#__PURE__*/ React.createElement(AnswerText, null, getLocalizedProperty(answer, "value"), !hideHelpText && answer.help && /*#__PURE__*/ React.createElement(_$RenderHelpText, {
                    selected: selectedAnswer,
                    answer: answer
                })), /*#__PURE__*/ React.createElement(AnswerIcon, null, displaySelectedIcon && selectedAnswer && /*#__PURE__*/ React.createElement(FaCheck, {
                    size: 18,
                    color: context.theme.components.decisionTree.answers.selectedAnswerColor || context.theme.components.decisionTree.answers.color
                })));
            }), !answers.length && /*#__PURE__*/ React.createElement("p", null, "There are no answers defined for this question.")))), /*#__PURE__*/ React.createElement(Footer, {
                className: "decision-tree-footer"
            }, /*#__PURE__*/ React.createElement(DecisionTreeFooter, null, /*#__PURE__*/ React.createElement(Button, {
                disabled: _this.currentQuestionNumber === 1,
                onClick: _this.previousQuestion
            }, !question.final ? i18n("decisionTree.quoteBuilder.previousQuestion") : i18n("decisionTree.quoteBuilder.goBack")), !question.noQuote && /*#__PURE__*/ React.createElement(React.Fragment, null, question.final ? _this.props.startOverOnMessageEnd && question.type === "message" ? /*#__PURE__*/ React.createElement(Button, {
                onClick: _this.resetDecisionTree
            }, /*#__PURE__*/ React.createElement(MdReplay, null), " ", i18n("decisionTree.quoteBuilder.startOver")) : !noBuildQuote && /*#__PURE__*/ React.createElement(Button, {
                onClick: _this.buildQuote
            }, buildQuoteLabel) : /*#__PURE__*/ React.createElement(Button, {
                disabled: !decisionTreeAnswers[_this.currentQuestionNumber],
                onClick: _this.nextQuestion
            }, i18n("decisionTree.quoteBuilder.nextQuestion"))), startOverBtnEachQuestion && !question.final && _this.currentQuestionNumber !== 1 && /*#__PURE__*/ React.createElement(Button, {
                onClick: _this.resetDecisionTree
            }, i18n("decisionTree.quoteBuilder.startOver"))))));
        };
        _this.state = {
            currentQuestion: ((ref = props.flow) === null || ref === void 0 ? void 0 : ref.question) || {},
            buildQuote: false,
            animateContent: true,
            autoMoved: false
        };
        return _this;
    }
    var _proto = _DecisionTree.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.getDecisionTreeReset) {
            this.props.getDecisionTreeReset(this.resetDecisionTree);
        }
        if (this.props.getDecisionTreeBackToQuestions) {
            this.props.getDecisionTreeBackToQuestions(this.handleBackToQuestions);
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        if (this.props.decisionTreeFlowsFetch.value && !((ref = this.state.currentQuestion) === null || ref === void 0 ? void 0 : ref.id) && !((ref1 = this.state.currentQuestion) === null || ref1 === void 0 ? void 0 : ref1.value)) {
            this.setCurrentQuestion(this.props.decisionTreeFlowsFetch.value.question);
        }
        if (((ref2 = this.props.getNextDecisionTreeFlowsFetch) === null || ref2 === void 0 ? void 0 : ref2.settled) && !prevProps.getNextDecisionTreeFlowsFetch.settled) {
            var ref9;
            var question = (ref9 = this.props.getNextDecisionTreeFlowsFetch.value) === null || ref9 === void 0 ? void 0 : ref9.question;
            if (question) {
                this.setCurrentQuestion(question);
            }
        }
        if (this.props.autoSelectedAnswer && ((ref3 = context.state.decisionTreeAnswers) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[1]) === null || ref4 === void 0 ? void 0 : ref4.id) !== ((ref5 = this.props.autoSelectedAnswer) === null || ref5 === void 0 ? void 0 : ref5.id)) {
            var ref10;
            this.answerSelected(this.props.autoSelectedAnswer, (ref10 = context.state.flow) === null || ref10 === void 0 ? void 0 : ref10.question);
            this.currentQuestion = this.props.autoSelectedAnswer.question;
        }
        if (this.props.autoSelectedAnswer && ((ref6 = context.state.decisionTreeAnswers) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[1]) === null || ref7 === void 0 ? void 0 : ref7.id) === ((ref8 = this.props.autoSelectedAnswer) === null || ref8 === void 0 ? void 0 : ref8.id) && !this.state.autoMoved) {
            this.nextQuestion();
            this.setState({
                autoMoved: true
            });
        }
        if (this.props.shouldResetDecisionTree) {
            this.resetDecisionTree();
            updateContextState(function(state) {
                state.shouldResetDecisionTree = false;
            });
        }
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1;
        var _props = this.props, decisionTreeFlowsFetch = _props.decisionTreeFlowsFetch, flow = _props.flow;
        var currentQuestion = ((ref = this.state.currentQuestion) === null || ref === void 0 ? void 0 : ref.id) || ((ref1 = this.state.currentQuestion) === null || ref1 === void 0 ? void 0 : ref1.final) ? this.state.currentQuestion : flow.question;
        if (decisionTreeFlowsFetch.pending || !currentQuestion) {
            return /*#__PURE__*/ React.createElement(Progress, null);
        } else if (decisionTreeFlowsFetch.rejected) {
            return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, /*#__PURE__*/ React.createElement(MutedText, null, "An error occurred while loading the decision tree")))));
        } else if (decisionTreeFlowsFetch.value === null) {
            return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, /*#__PURE__*/ React.createElement(MutedText, null, "Currently there is no decision tree available")))));
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, this.props.asCard ? /*#__PURE__*/ React.createElement(Card, {
            noBorder: this.props.noBorder
        }, function(props) {
            return _this.renderCard(_objectSpreadProps(_objectSpread({}, props), {
                question: currentQuestion
            }));
        }) : /*#__PURE__*/ React.createElement(React.Fragment, null, this.renderCard({
            Header: function(props) {
                return /*#__PURE__*/ React.createElement(React.Fragment, null, props.children);
            },
            Body: function(props) {
                return /*#__PURE__*/ React.createElement(React.Fragment, null, props.children);
            },
            Footer: function(props) {
                return /*#__PURE__*/ React.createElement(React.Fragment, null, props.children);
            },
            question: currentQuestion
        })));
    };
    return _DecisionTree;
}(Component);
_DecisionTree.propTypes = {
    buildQuoteLabel: propTypes.string,
    renderFinalQuestionHelpText: propTypes.bool,
    asCard: propTypes.bool,
    finalStepTitleHide: propTypes.bool,
    startOverBtnEachQuestion: propTypes.bool,
    startOverResetFlow: propTypes.bool,
    RenderHelpText: propTypes.any,
    emailSupportLabel: propTypes.any,
    onNextQuestion: propTypes.func,
    decisionTreeAnswers: propTypes.any,
    flow: propTypes.any,
    getDecisionTreeReset: propTypes.func,
    getDecisionTreeBackToQuestions: propTypes.func,
    getNextDecisionTreeFlowsFetch: propTypes.oneOfType([
        propTypes.object,
        propTypes.func
    ]),
    onReset: propTypes.func,
    restoreState: propTypes.object,
    submitProposal: propTypes.func,
    asDoc: propTypes.bool,
    asPdf: propTypes.bool,
    hideHelpText: propTypes.bool,
    showVMSButton: propTypes.bool,
    initialValues: propTypes.object,
    validationSchema: propTypes.object,
    noSummary: propTypes.bool,
    noBuildQuote: propTypes.bool,
    valuesTypes: propTypes.object,
    customFinalProductsView: propTypes.func,
    decisionTreeFlowsFetch: propTypes.object,
    noBorder: propTypes.bool,
    sowBuilderSummaryText: propTypes.node,
    startOverOnMessageEnd: propTypes.bool,
    autoSelectedAnswer: propTypes.object,
    showQuestionHelper: propTypes.bool,
    shouldResetDecisionTree: propTypes.bool
};
_DecisionTree.defaultProps = {
    buildQuoteLabel: i18n("decisionTree.quoteBuilder.buildQuote"),
    RenderHelpText: RenderHelpText,
    renderFinalQuestionHelpText: false,
    asCard: true,
    finalStepTitleHide: false,
    emailSupportLabel: null,
    startOverBtnEachQuestion: false,
    startOverResetFlow: false,
    showQuestionHelper: false
};
var DecisionTree = withContext(connectRequest(function(param) {
    var flowId = param.flowId, selectedCatalogId = param.selectedCatalogId;
    return {
        decisionTreeFlowsFetch: flowId ? requests.fetchDecisionTreeFlowById(flowId) : requests.fetchDecisionTreeFlows(selectedCatalogId),
        getNextDecisionTreeFlowsFetch: function(flowId) {
            return {
                getNextDecisionTreeFlowsFetch: requests.fetchDecisionTreeFlowById(flowId)
            };
        }
    };
})(_DecisionTree), {
    mapProps: function(context) {
        return {
            decisionTreeAnswers: context.state.decisionTreeAnswers,
            selectedCatalogId: context.state.selectedCatalogId,
            flow: context.state.flow,
            shouldResetDecisionTree: context.state.shouldResetDecisionTree
        };
    }
});
export default DecisionTree;
